import { useState } from 'react';

function Tooltip({content, option}: {content: any, option?: any}) {
	const [isDisplay, setIsDisplay] = useState<boolean>(false)

	return (
		<div className="tooltip">
			<div className="tooltip__icon" aria-label="Information" onMouseEnter={() => setIsDisplay(true)}  onMouseLeave={() => setIsDisplay(false)}>
				i
			</div>
			{isDisplay ?
				<div className={`tooltip__bubble ${option?.right ? 'right' : ''}`} role="tooltip">
					{content}
				</div>
			: ''}
		</div>
		);
	};

export default Tooltip;